import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Auth/Login/Login';
import ForgetPassword from './pages/Auth/ForgetPassword/ForgetPassword';
import ResetPassword from './pages/Auth/ResetPassword/ResetPassword';
import { useAuth } from './context/AuthContext';
import TeacherLayout from './components/TeacherLayout/TeacherLayout';
import ProtectedRoute from './helper/ProtectedRoute';
import Dashboard from './pages/Teacher/Dashboard/Dashboard';
import PageNotFound from './pages/PageNotFound/PageNotFound';
import Sessions from './pages/Teacher/Sessions/Sessions';
import Schedule from './pages/Teacher/Schedule/Schedule';
import Chat from './pages/Teacher/Chat/Chat';
import MyAccount from './pages/Teacher/MyAccount/MyAccount';
import SessionDetails from './pages/Teacher/SessionDetails/SessionDetails';
import Wallet from './pages/Teacher/Wallet/Wallet';
import PrivacyPolicy from './pages/Auth/PrivacyPolicy/PrivacyPolicy';
import EditSpecialisation from './components/MyAccount/EditSpecialisation/EditSpecialisation';
import { RouteRounded } from '@mui/icons-material';
import RescheduledRequest from './components/MyAccount/RescheduledRequest/RescheduledRequest';
import RescheduledRequestDetail from './components/MyAccount/RescheduledRequest/RescheduledRequestDetail';
import VerifyOTP from './pages/Auth/LoginWithOTP/VerifyOTP';

function App() {
  const [auth, , loading] = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-otp" element={<VerifyOTP />} />
        <Route
          path="/"
          element={
            auth?.user_type === 'teacher' ? (
              <Navigate to="/instructor/dashboard" />
            ) : (
              <Navigate to="/page-not-found" />
            )
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        {auth?.user_type === 'teacher' && (
          <Route element={<TeacherLayout />}>
            <Route
              path="/instructor/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/instructor/sessions"
              element={
                <ProtectedRoute>
                  <Sessions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/instructor/sessions-details/:sessionId"
              element={
                <ProtectedRoute>
                  <SessionDetails />
                </ProtectedRoute>
              }
            />

            <Route
              path="/instructor/schedule"
              element={
                <ProtectedRoute>
                  <Schedule />
                </ProtectedRoute>
              }
            />
            <Route
              path="/instructor/chat"
              element={
                <ProtectedRoute>
                  <Chat />
                </ProtectedRoute>
              }
            />
            <Route
              path="/instructor/account"
              element={
                <ProtectedRoute>
                  <MyAccount />
                </ProtectedRoute>
              }
            />
            <Route
              path="/instructor/account/wallet"
              element={
                <ProtectedRoute>
                  <Wallet />
                </ProtectedRoute>
              }
            />
            <Route
              path="/instructor/account/edit-specialisation"
              element={
                <ProtectedRoute>
                  <EditSpecialisation />
                </ProtectedRoute>
              }
            />

            <Route
              path="/instructor/account/reschedule-request"
              element={
                <ProtectedRoute>
                  <RescheduledRequest />
                </ProtectedRoute>
              }
            />

            <Route
              path="/instructor/account/reschedule-request-detail/:requestId"
              element={
                <ProtectedRoute>
                  <RescheduledRequestDetail />
                </ProtectedRoute>
              }
            />
          </Route>
        )}
        <Route path="*" element={auth?.access_token ? <PageNotFound /> : <Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
